export default {
  data() {
    return {
      websocketDisconnectNotificationSentAt: null,
      websocketDisconnectedAt: null,
      websocketNotificationInProgress: false,
      websocketStatusListenerAttached: false,
      websocketNotificationResendDelay: 60000,
      websocketNotificationReconnectDelay: 3500,
      websocketLastKnownStatus: null,
      websocketMixpanelNotificationSent: false
    };
  },
  methods: {
    isWebsocketNotificationResendDelayMet() {
      if (this.websocketDisconnectNotificationSentAt === null) {
        return true;
      }

      return (
        Date.now() - this.websocketDisconnectNotificationSentAt >
        this.websocketNotificationResendDelay
      );
    },
    attachWebsocketStatusListener() {
      this.$eventHub.$on('websocket-connection-status-change', status => {
        if (status === this.sockets.connectionStatuses.CONNECTED) {
          this.websocketDisconnectedAt = null;
        }

        if (status !== this.sockets.connectionStatuses.CONNECTED) {
          this.websocketDisconnectedAt = this.websocketDisconnectedAt || Date.now();

          if (!this.websocketNotificationInProgress) {
            this.websocketNotificationInProgress = true;
            setTimeout(() => {
              if (this.websocketDisconnectedAt) {
                if (this.isWebsocketNotificationResendDelayMet()) {
                  this.websocketDisconnectNotificationSentAt = Date.now();
                  this.notify(
                    'Websocket connection failure. <br />For more information click the connection icon in the navigation bar',
                    'error'
                  );
                }
              }
              this.websocketNotificationInProgress = false;
            }, this.websocketNotificationReconnectDelay);
          }
        }

        const statusData = this.$websocketConnectionStatus;
        statusData.state = status;

        if (
          status === this.sockets.connectionStatuses.CONNECTED ||
          this.websocketLastKnownStatus === this.sockets.connectionStatuses.CONNECTED
        ) {
          statusData.lastConnected = new Date();
        }

        this.$store.commit('Websockets/setConnectionStatus', statusData);

        if (
          this.$websocketConnectionStatus.lastConnected &&
          status !== this.sockets.connectionStatuses.CONNECTED &&
          Date.now() - this.$websocketConnectionStatus.lastConnected >
            this.websocketNotificationResendDelay &&
          !this.websocketMixpanelNotificationSent
        ) {
          this.mixpanel.track(this.mixpanel.events.SYSTEM.ERROR.WEBSOCKET_CONNECTION);
          this.websocketMixpanelNotificationSent = true;
        }

        this.websocketLastKnownStatus = status;
      });
    }
  },
  mounted() {
    if (!this.websocketStatusListenerAttached) {
      this.websocketStatusListenerAttached = true;
      this.attachWebsocketStatusListener();
    }
  }
};
